import { render, staticRenderFns } from "./AlarmLogDetail.vue?vue&type=template&id=83084e08&scoped=true&"
import script from "./AlarmLogDetail.vue?vue&type=script&lang=js&"
export * from "./AlarmLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlarmLogDetail.vue?vue&type=style&index=0&id=83084e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83084e08",
  null
  
)

export default component.exports